export default {
  name: 'marking--orderUpdateAllStatuses',
  apiService: 'shoes',
  apiPath: '/admin/order/func/update_all_status',
  urlParamName: 'marking--orderUpdateAllStatuses',
};